import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const taskPointList = [
    {
        img: '/images/svg/zkhfoundation/time.svg',
        title: 'Сжатые сроки',
        text: 'Одним из&nbsp;вызовов в&nbsp;реализации комплексного проекта для фонда ЖКХ было выполнить 6&nbsp;основных задач, каждая с&nbsp;жестким дедлайном и&nbsp;большим объемом работы. Все этапы были рассчитаны в&nbsp;общей сумме на&nbsp;8&nbsp;месяцев. Это очень маленький срок для такого объема задач, даже с&nbsp;учетом распределенных команд. Но&nbsp;мы&nbsp;смогли, благодаря отлаженной командной работе, грамотному планированию и&nbsp;приоритизации.',
    },
    {
        img: '/images/svg/zkhfoundation/tree.svg',
        title: 'Древовидная структура',
        text: 'За&nbsp;время развития проекта структура сайта разрослась до&nbsp;пятиуровневого дерева и&nbsp;требовала серьезной оптимизации. Чтобы решить эту проблему, мы&nbsp;перегруппировали разделы, удалили все лишнее, наладили систему фильтрации и&nbsp;внедрили систему тегирования. В&nbsp;итоге мы&nbsp;перенесли 18246&nbsp;новостей.',
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} caseName="zkhfoundation-complex">
                <div className="zkhfoundation-complex__wrapper">
                    <div className="zkhfoundation-complex__grid">
                        <div className="zkhfoundation-complex__info">
                            <CommonTitle className="zkhfoundation-complex__title">
                                Сложности
                            </CommonTitle>
                            <CommonUsualText className="zkhfoundation-complex__subtitle">
                                Нам пришлось столкнуться с&nbsp;выполнением задач за&nbsp;очень
                                короткие сроки и&nbsp;переработать общую структуру проекта.
                            </CommonUsualText>
                        </div>
                        <div className="zkhfoundation-complex__points">
                            {taskPointList.map(({ img, title, text }, index) => (
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                    className="zkhfoundation-complex__point-item"
                                    key={index}
                                >
                                    <div className="zkhfoundation-complex__point-title">
                                        <img
                                            className="zkhfoundation-complex__point-img"
                                            src={img}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <CommonSmallTitle>{parse(title)}</CommonSmallTitle>
                                    </div>
                                    <CommonSmallText className="zkhfoundation-complex__point-text">
                                        {parse(text)}
                                    </CommonSmallText>
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
